import React, { useState } from 'react';
import axios from 'axios';
import '../components/CreatePost.css';

function CommunityActivityForm({ communityId, onCreated }) {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [articleUrl, setArticleUrl] = useState('');
  const [linkPreview, setLinkPreview] = useState(null);

  const resetFields = () => {
    setContent('');
    setArticleUrl('');
    setLinkPreview(null);
  };

  const handleFetchPreview = async () => {
    const url = articleUrl.trim();
    if (!url) return;
    setPreviewLoading(true);
    try {
      const response = await axios.get('/api/link-preview', { params: { url } });
      setLinkPreview(response.data);
      if (!content.trim() && response.data.title) {
        setContent(response.data.title);
      }
    } catch (error) {
      alert('Failed to fetch link preview');
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!linkPreview) {
      alert('Please fetch the article link preview first');
      return;
    }
    setLoading(true);
    try {
      const payload = {
        content: content.trim() || linkPreview.title || '',
        postType: 'ARTICLE',
        linkUrl: linkPreview.url,
        linkTitle: linkPreview.title,
        linkDescription: linkPreview.description,
        linkImage: linkPreview.image
      };
      await axios.post(`/api/communities/${communityId}/posts`, payload);
      resetFields();
      if (onCreated) onCreated();
    } catch (error) {
      alert(error.response?.data?.message || 'Failed to post');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="community-post-form create-post-card" onSubmit={handleSubmit}>
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="Comment about this article (optional)"
        rows={3}
        maxLength={500}
      />

      <div className="post-type-fields">
        <div className="field-row">
          <input
            type="url"
            value={articleUrl}
            onChange={(e) => {
              setArticleUrl(e.target.value);
              setLinkPreview(null);
            }}
            placeholder="Paste article URL..."
            className="field-input"
          />
          <button type="button" className="secondary-btn" onClick={handleFetchPreview} disabled={previewLoading || !articleUrl.trim()}>
            {previewLoading ? 'Fetching...' : 'Fetch Preview'}
          </button>
        </div>
        {linkPreview && (
          <div className="link-preview-card">
            {linkPreview.image && (
              <img src={linkPreview.image} alt="" className="link-preview-image" />
            )}
            <div className="link-preview-body">
              <div className="link-preview-title">{linkPreview.title || linkPreview.url}</div>
              {linkPreview.description && <div className="link-preview-description">{linkPreview.description}</div>}
              <div className="link-preview-url">{linkPreview.url}</div>
            </div>
            <button type="button" className="remove-preview-btn" onClick={() => setLinkPreview(null)}>
              Remove
            </button>
          </div>
        )}
      </div>

      <button type="submit" className="btn-primary" disabled={loading || !linkPreview}>
        {loading ? 'Posting...' : 'Share Article'}
      </button>
    </form>
  );
}

export default CommunityActivityForm;
